import React from 'react'
import { Panel, FormPanel, Button, Container, Label, Toolbar } from '@sencha/ext-modern'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { doGetPlan } from 'tyan/reducers/actions'
import Message from 'tyan/components/Message'

const style = {
	outer: {
		backgroundColor: "#f5f5f5",
		padding: "10px",
	},
	innerContainer: {
		borderRadius: "10px",
		backgroundColor: "#ffffff",
		padding: "10px",
		width: "100%",
	},
	titleContainer: {
		borderBottom: "1px solid #f5f5f5",
	},
}
class DetailPlan extends React.Component {
	state = {
		plan: null,
		errorMessage: null,
		planMessage: null
	}

	componentDidMount() {
		const { doGetPlan, match: { params: { contractID } } } = this.props
		doGetPlan({
			contractID,
			onEnd: ({ plan, errorMessage }) => {
				this.setState({ plan, errorMessage })
			}
		})
	}

	handleBack = () => {
		const { history, match: { params: { source } } } = this.props
		history.goBack()

	}

	handleClick = o => {
		location.hash = `/QYWX/PlanStartInfo/${o.planID}`
	}

	render() {
		const { plan, errorMessage, planMessage } = this.state
		if (errorMessage) {
			return <Message text="数据加载失败" subText={errorMessage} />
		} else if (!plan) {
			return <Message text="数据加载中..." />
		}
		const panelProps = {
			height: "100%",
			margin: '0 0 0 0',
			padding: '0 0 0 0'
		}
		return (
			<Panel shadow layout="vbox" {...panelProps} style={{ backgroundColor: '#fefbe2' }}>
				<Container layout="fit" flex={4}>
					<FormPanel shadow padding="20">
						<FormPanel layout={{ type: 'vbox', align: 'center', pack: "start" }}>
							{plan && plan.testList.map((o, index) => {
								return (
									<Button key={index}
										ui="raised action"
										text={index + 1 + '.' + o.name} margin="5" width="100%" textAlign="left" style={{color:'black'}}
										handler={() => this.handleClick(o)}
									/>
								)
							})}
						</FormPanel>
					</FormPanel>
				</Container>
			</Panel>
		)
	}
}

const mapStateToProps = ({ }) => ({})

export default compose(
	connect(mapStateToProps, { doGetPlan })
)(DetailPlan)